import React from "react";
import { parsePpeValues } from "./permitHelpers";

export const ProvidedPpeBadges = ({ value }) => {
  const items = parsePpeValues(value);

  if (!items.length) {
    return <span className="text-sm font-medium text-slate-400">N/A</span>;
  }

  return (
    <div className="mt-1.5 flex flex-wrap gap-2">
      {items.map((item) => (
        <span
          key={item}
          className="inline-flex items-center rounded-full border border-green-200 bg-green-50 px-3 py-1 text-xs font-semibold text-green-700"
        >
          {item}
        </span>
      ))}
    </div>
  );
};

export default ProvidedPpeBadges;